import { Component, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { CreateSparkCampaign } from '../../service/create-spark-campaign/create-spark-campaign';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateSparkCampaignResponseDto } from '@/app/common/general-types/tiktok-spark-ads.dto';
import { CreateSparkAdGroupRequestDto } from '@/app/common/general-types/spark-ads-v3.dto';
import { TiktokSparkAdsService } from '@/app/services/tiktok-spark-ads/tiktok-spark-ads.service';
import { GroupName } from './atoms/group-name/group-name';
import { GroupPlacements } from './atoms/group-placements/group-placements';
import { GroupTargeting } from './atoms/group-targeting/group-targeting';
import { GroupBrandSafetySuitability } from './atoms/group-brand-safety-suitability/group-brand-safety-suitability';
import { GroupBudgetSchedule } from './atoms/group-budget-schedule/group-budget-schedule';
import { GroupBiddingOptimization } from './atoms/group-bidding-optimization/group-bidding-optimization';

@Component({
  selector: 'app-create-ad-group',
  imports: [GroupName, GroupPlacements, GroupTargeting,
    GroupBudgetSchedule,
    GroupBiddingOptimization,
  ],
  templateUrl: './create-ad-group.html',
  styleUrl: './create-ad-group.css',
})
export class CreateAdGroup implements OnInit {

  briefId = signal<string | undefined>(undefined);
  campaignId = signal<string | undefined>(undefined);

  /** Services */
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);
  public createSparkCampaignService = inject(CreateSparkCampaign);
  private tiktokSparkAdsService = inject(TiktokSparkAdsService);
  /** Services - END */

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const campaignId = params['campaignId'];
      const briefId = params['briefId'];
      this.campaignId.set(campaignId);
      this.briefId.set(briefId);
      console.log('CreateAdGroup - campaignId: ', campaignId);
      console.log('CreateAdGroup - briefId: ', briefId);

      if (this.createSparkCampaignService.currentSparkCampaign() && this.createSparkCampaignService.currentSparkCampaign()!.id === campaignId) {
        console.log('Campaign Focussed...')
        this.createSparkCampaignService.loadLocations({
          briefId,
          /** TikTok tool/region `level_range`: TO_COUNTRY = country roots with deeper levels available. */
          levelRange: 'TO_COUNTRY',
        });
        this.createSparkCampaignService.loadLanguages({ briefId });
      } else {
        this.getAssociatedCampaign(briefId);
      }
    });
  }

  getAssociatedCampaign(briefId: string) {
    console.log('getAssociatedCampaign() ---> ');
    this.tiktokSparkAdsService.getSparkCampaignForBrief(briefId).subscribe({
      next: (campaign: CreateSparkCampaignResponseDto | null) => {
        if (!campaign) {
          return;
        }
        this.createSparkCampaignService.currentSparkCampaign.set(campaign);
        this.createSparkCampaignService.loadLocations({
          briefId,
          levelRange: 'TO_COUNTRY',
        });
        this.createSparkCampaignService.loadLanguages({ briefId });
      },
      error: (err) => {
        console.error('getAssociatedCampaign() ---> error: ', err);
      },
    });
  }

  checkAdGroup() {
    console.log('checkAdGroup() ---> ');
    console.log('createSparkCampaignService.currentSparkCampaign(): ', this.createSparkCampaignService.currentSparkCampaign());
    console.log('// Basics //');
    console.log('createSparkCampaignService.adGroupName(): ', this.createSparkCampaignService.adGroupName());
    console.log('// Placements //');
    console.log('createSparkCampaignService.placement_type(): ', this.createSparkCampaignService.placement_type());
    console.log('createSparkCampaignService.comment_disabled(): ', this.createSparkCampaignService.comment_disabled());
    console.log('createSparkCampaignService.video_download_disabled(): ', this.createSparkCampaignService.video_download_disabled());
    console.log('createSparkCampaignService.share_disabled(): ', this.createSparkCampaignService.share_disabled());
    console.log('// Targeting //');
    console.log('createSparkCampaignService.location_ids(): ', this.createSparkCampaignService.location_ids());
    console.log('createSparkCampaignService.is_hfss(): ', this.createSparkCampaignService.is_hfss());
    console.log('createSparkCampaignService.age(): ', this.createSparkCampaignService.age());
    console.log('createSparkCampaignService.gender(): ', this.createSparkCampaignService.gender());
    console.log('createSparkCampaignService.languages(): ', this.createSparkCampaignService.languages());
    console.log('createSparkCampaignService.spending_power(): ', this.createSparkCampaignService.spending_power());
    console.log('createSparkCampaignService.smart_interest_behavior_enabled(): ', this.createSparkCampaignService.smart_interest_behavior_enabled());
    console.log('createSparkCampaignService.operating_systems(): ', this.createSparkCampaignService.operating_systems());
    console.log('// Budget & Schedule //');
    console.log('createSparkCampaignService.selectedBudgetModeAdGroup(): ', this.createSparkCampaignService.selectedBudgetModeAdGroup());
    console.log('createSparkCampaignService.budgetAdGroup(): ', this.createSparkCampaignService.budgetAdGroup());
    console.log('createSparkCampaignService.startDateAdGroup(): ', this.createSparkCampaignService.startDateAdGroup());
    console.log('createSparkCampaignService.endDateAdGroup(): ', this.createSparkCampaignService.endDateAdGroup());
    console.log('// Bidding & Optimization //');
    console.log('createSparkCampaignService.frequency(): ', this.createSparkCampaignService.frequency());
    console.log('createSparkCampaignService.frequency_schedule(): ', this.createSparkCampaignService.frequency_schedule());
    console.log('createSparkCampaignService.bid_price(): ', this.createSparkCampaignService.bid_price());


    const newGroup: Record<string, unknown> = {
      advertiser_id: this.createSparkCampaignService.currentSparkCampaign()?.advertiserId,
      campaign_id: this.createSparkCampaignService.currentSparkCampaign()?.tiktokCampaignId,
      adgroup_name: this.createSparkCampaignService.adGroupName(),
      // promotion_type: this.createSparkCampaignService.currentSparkCampaign().
      placement_type: this.createSparkCampaignService.placement_type(),
      placements: this.createSparkCampaignService.placements(),
      video_download_disabled: this.createSparkCampaignService.video_download_disabled(),
      share_disabled: this.createSparkCampaignService.share_disabled(),
      comment_disabled: this.createSparkCampaignService.comment_disabled(),
      location_ids: this.createSparkCampaignService.location_ids(),
      is_hfss: this.createSparkCampaignService.is_hfss(),
      age: this.createSparkCampaignService.age(),
      gender: this.createSparkCampaignService.gender(),
      languages: this.createSparkCampaignService.languages(),
      spending_power: this.createSparkCampaignService.spending_power(),
      smart_interest_behavior_enabled: this.createSparkCampaignService.smart_interest_behavior_enabled(),
      operating_systems: this.createSparkCampaignService.operating_systems(),
      budget_mode: this.createSparkCampaignService.selectedBudgetModeAdGroup(),
      budget: this.createSparkCampaignService.budgetAdGroup(),
      schedule_type: "SCHEDULE_START_END",
      schedule_end_time: this.createSparkCampaignService.endDateAdGroup(),
      schedule_start_time: this.createSparkCampaignService.startDateAdGroup(),
      frequency: this.createSparkCampaignService.frequency(),
      frequency_schedule: this.createSparkCampaignService.frequency_schedule(),
      bid_price: this.createSparkCampaignService.bid_price(),
      bid_type: this.createSparkCampaignService.bid_type(),
      optimization_goal: this.createSparkCampaignService.optimization_goal(),
      billing_event: this.createSparkCampaignService.billing_event(),
      optimization_event: this.createSparkCampaignService.optimization_event(),
      promotion_type: this.createSparkCampaignService.promotion_type(),
      secondary_optimization_event: this.createSparkCampaignService.secondary_optimization_event(),
      pixel_id: this.createSparkCampaignService.pixel_id(),
      pacing: "PACING_MODE_SMOOTH",
      operation_status: "ENABLE"
    };

    const payload: Record<string, unknown> = {};
    for (const key of Object.keys(newGroup)) {
      const value = newGroup[key];
      if (value !== undefined) {
        payload[key] = value;
      }
    }

    console.log('createSparkAdGroup() ---> ');
    /**
     * This legacy screen assembles the payload untyped and strips undefined keys by
     * hand. The cast keeps the now-typed service contract intact; it goes away with
     * this component when Spark Ads v3 replaces it.
     */
    this.tiktokSparkAdsService
      .createSparkAdGroup(payload as unknown as CreateSparkAdGroupRequestDto)
      .subscribe({
      next: (adGroup: any) => {
        console.log('createSparkAdGroup() ---> adGroup: ', adGroup);

      },
      error: (err) => {
        console.error('createSparkAdGroup() ---> error: ', err);

      },
    });

  }

  backToBriefs() {
    console.log('backToBriefs() ---> ');
    const briefId = this.briefId();
    if (globalThis.history.length > 1) {
      this.location.back();
    } else if (briefId) {
      void this.router.navigate(['/manage-brief', briefId]);
    }
  }

}
